<template>
  <svg
    width="20"
    height="20"
    viewBox="12 15 16 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2778 26.2408L15.3777 18.1067L21.2019 18.0049L27.026 17.9031V34.3599L24.0677 31.419L21.1094 28.4781L18.1437 31.4264L15.1779 34.3748L15.2778 26.2408ZM12.9741 23.6843V15.7031H18.8907C23.8543 15.7031 24.8073 15.7908 24.8073 16.2477C24.8073 16.6969 23.8851 16.8101 19.5378 16.8948L14.2684 16.9974L14.0835 24.1779C13.9475 29.4586 13.7763 31.3991 13.4364 31.512C13.0761 31.6317 12.9741 29.9047 12.9741 23.6843Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'RemarkTag',
} as DefineComponent
</script>
